import { sortBy } from 'lodash';

import { Label, LabelsByBoards } from '../../../../../../../common/labels/labelTypes';

export const MAX_RECENT_LABELS = 5;
export const RECENT_LABELS_SECTION_ID = 'recent-labels';

/**
 * Returns a capped list of the user's most recently created labels.
 */
export const getRecentLabels = (allLabels: Label[], currentUserId: string): Label[] => {
    return sortBy(
        allLabels.filter((label) => label.meta.creator === currentUserId),
        [(label) => -label.meta.createdTime],
    ).slice(0, MAX_RECENT_LABELS);
};

/**
 * Wraps recent labels in a suggestion section shape for the popup.
 */
export const createRecentLabelsSection = (
    allLabels: Label[],
    currentUserId: string,
    recentlyCreatedTitle: string,
): LabelsByBoards => {
    const recentLabels = getRecentLabels(allLabels, currentUserId);
    if (!recentLabels.length) return [];

    return [
        {
            id: RECENT_LABELS_SECTION_ID,
            title: recentlyCreatedTitle,
            labels: recentLabels,
        },
    ];
};

export const translateRootBoardTitle = (
    labelsByBoards: LabelsByBoards,
    translatedHomeTitle: string,
): LabelsByBoards => {
    for (let index = 0; index < labelsByBoards.length; index += 1) {
        const group = labelsByBoards[index];
        if (!group.isRoot) continue;

        if (group.title === translatedHomeTitle) return labelsByBoards;

        const updatedLabelsByBoards = [...labelsByBoards];
        updatedLabelsByBoards[index] = { ...group, title: translatedHomeTitle };
        return updatedLabelsByBoards;
    }

    return labelsByBoards;
};
